import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getCommodityKPIsAsync } from 'src/services/costModelling/shouldCostLibrary.services'
import { formatNumber } from 'src/utils/Functions/aggridUtils/customValueFormatter'

// transform commodity data for trendline chart
const transformCommodityTrendlineData = (commodityTrendData) => {
  const transformed = commodityTrendData.map((obj) => ({
    ...obj,
    cost: obj?.cost,
    calendar_date: obj?.calendar_date,
    category: obj?.category,
    currency_code: 'USD',
    currency_symbol: '$',
    formattedValueY:  obj?.cost > 0 ? formatNumber(obj.cost) : 0,
  }))

    return transformed
}

const initialState = {
  getCommodityKPIsLoader: false,
  getCommodityKPIs: {
    kpiData: {},
    commodityTrendlineData: [],
  },
  getCommodityKPIsError: '',
  forwardFillDate: null,
}

export const getCommodityKPIsSlice = createSlice({
  name: 'get-commodity-kpis',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getCommodityKPIsAsync.pending), (state) => {
      state.getCommodityKPIsLoader = true
    })
    builder.addMatcher(isAnyOf(getCommodityKPIsAsync.fulfilled), (state, action) => {
      state.getCommodityKPIsLoader = false
      state.getCommodityKPIs.kpiData = action.payload.data.kpi
      state.getCommodityKPIs.commodityTrendlineData = action?.payload?.data?.trend_chart ? transformCommodityTrendlineData(action?.payload?.data?.trend_chart) : []
      state.forwardFillDate = action.payload.data?.forward_fill_date ?? null
    })
    builder.addMatcher(isAnyOf(getCommodityKPIsAsync.rejected), (state, action) => {
      state.getCommodityKPIsLoader = false
      state.getCommodityKPIsError = action.payload.message
    })
  },
  reducers: {
    resetCommodityKPIs: () => initialState,
  },
})

export const { resetCommodityKPIs } = getCommodityKPIsSlice.actions

export default getCommodityKPIsSlice.reducer
